@if (!hasError) {
  <div class="title">{{ summaryStatsStatus === 'SummaryStatsCompleted' ? 'Report complete' : 'Creating report' }}</div>
  <div class="spinner-container">
    <mat-progress-spinner 
      [mode]="summaryStatsStatus === 'SummaryStatsCompleted' ? 'determinate' : 'indeterminate'" 
      [value]="summaryStatsStatus === 'SummaryStatsCompleted' ? 100 : 0" 
      class="background-spinner">
    </mat-progress-spinner>
    <mat-progress-spinner
      [mode]="summaryStatsStatus === 'SummaryStatsCompleted' ? 'determinate' : 'indeterminate'"
      [value]="summaryStatsStatus === 'SummaryStatsCompleted' ? 100 : 0"
      class="percentage-spinner">
    </mat-progress-spinner>
  </div>
  <div class="message-container">
    <span class="summary-text">
      Batch reports for many catchments may take a long time.
    </span>
  </div>
} 
@else {
  <div class="title title-error">Error</div>
  <div class="error-spinner-container">
    <mat-progress-spinner [mode]="'determinate'" [value]="100" class="error-spinner">
    </mat-progress-spinner>
    <div class="error-text">
      <span>N/A</span>
    </div>
  </div>
}
